import BaseUseCase from "../base_use_case.js";
import GwtTokenStorage from "../../utils/gwt_token_storage.js";

class LoginUseCase extends BaseUseCase {

  execute(params) {
    GwtTokenStorage.clear();
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/sessions`,
      data: this.wrapParams(params, "user")
    }).then((result) => {
      const { headers: { authorization } } = result;
      GwtTokenStorage.store(authorization);
      return result;
    });
  }
}

const instance = new LoginUseCase();
export default instance;